import { CartLineT, LineItemType } from '@lambda/apis/src/cart/types';

export type CartSummaryT = {
  /** How many items the shopper is buying: devices and accessories. */
  itemCount: number;
  /** What those items cost, in minor units. */
  itemsTotal: number;
  /** Express shipping, in minor units. Zero means free delivery. */
  shippingTotal: number;
};

export const getCartSummary = (cartLines: CartLineT[]): CartSummaryT => {
  const lines = cartLines ?? [];

  const products = lines.filter((line) => line.type === LineItemType.PRODUCT);
  const shipping = lines.filter((line) => line.type === LineItemType.SHIPPING);

  return {
    itemCount: products.reduce((total, line) => total + line.quantity, 0),
    itemsTotal: products.reduce(
      (total, line) => total + Number(line.price) * line.quantity,
      0,
    ),
    shippingTotal: shipping.reduce(
      (total, line) => total + Number(line.price) * line.quantity,
      0,
    ),
  };
};
